<template>
   <table class="table table-sm" dir="rtl">
      <thead>
        <th>id</th>
        <th>طول</th>
        <th>مسی</th>
        <th>متراژ نمره 6</th>
        <th>متراژ نمره 10</th>
        <th>متراژ نمره 16</th>
        <th>متراژ نمره 25</th>
        <th>متراژ نمره 35</th>
        <th>متراژ نمره 50</th>
        <th>فیدر</th>
      </thead>
      <tbody>
        <tr v-for="(n, i) in cuLineArr" :key="i" >
            <td class="small">{{ n._id }}</td>
            <td class="small">{{ Math.round(n.real_length*100)/100}}</td>
            <td class="small">{{cond(n) }}</td>
            <td class="small">{{ n.cu['LV-Wire-Cu-6'] }}</td>
            <td class="small">{{ n.cu['LV-Wire-Cu-10'] }}</td>
            <td class="small">{{ n.cu['LV-Wire-Cu-16'] }}</td>
            <td class="small">{{ n.cu['LV-Wire-Cu-25'] }}</td>
            <td class="small">{{ n.cu['LV-Wire-Cu-35'] }}</td>
            <td class="small">{{ n.cu['LV-Wire-Cu-50'] }}</td>
<td>{{n.feeder_id_arr}}</td>
   
            <!--
               <td class="small">{{ n }}</td> -->


        </tr>
      </tbody>
    </table>
    <p>پایه ها</p>
    <excel-text-view 
    :arrayOfObjects="myData.polesArr" 
    :actionUrl="url+'/free-arr/poles/_id'"
    :colArray="['_id','pole_num','c_x','c_y']" class="form-control" ></excel-text-view>
    <p>خطوط</p>
    <excel-text-view :arrayOfObjects="myData.linesArr" 
    :actionUrl="url+'/free-arr/lv_lines/_id'"
    :colArray="['_id','r_spec','s_spec','t_spec','r_spec','n_spec','l_spec','cond_type','real_length','min_x','max_x']" class="form-control" ></excel-text-view>
</template>


<script>
import { ApiTls } from "../../src/app/tools/ApiTls";
import { UrlTls } from "../../src/app/tools/UrlTls";
import { LineTls } from "../app/tools/LineTls";
import excelTextView from './excelTextView.vue';
// import { PoleTls } from "../app/tools/PoleTls";

export default {
  components: { excelTextView },
name:'FeederCuCal',
props:['feederId'],
data(){
    return{
        myData: { linesArr: [], feeder: [], a_sub: [], polesArr: [], l_sub: [] },
        feeders:[],
        url:UrlTls.getBaseUrl(),
    }
},
mounted() {
    ApiTls.getFeederData(this.feederId, this.setResData);
  },
    methods: {
    setResData(res) {
      this.myData = res.data;
      
      this.feeders = [];
      // for(var j=0;j<this.myData.feeder.length;j++){
      //   this.feeders[this.myData.feeder[j]['']] = this.myData.feeder[j][''];
      // }
      for(var i= 0; i<this.myData.linesArr.length;i++){
        this.myData.linesArr[i]['cu'] = LineTls.sumCuLine(this.myData.linesArr[i]);
      }
      
    },
    cond(lineRow){
 return LineTls.convertRow2Cond(lineRow);
    },
  },
  computed: {
    cuLineArr(){
      return this.myData.linesArr;
    }
    // banches() {
    //   return PoleTls.sumBranches(this.myData.polesArr);
    // },
    // cuLines() {
    //   return LineTls.sumCuLines(this.myData.linesArr);
    // },
    // toShow() {
    //   return this.myData.real_length > 0;
    // },

  },
  watch: {
   
  },
}
</script>

<style>

</style>